(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1345],{

/***/ 56951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11101);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83974);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31969);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23158);






function BuilderHead(props) {
    var isRateParityWebAppPage = props.hasOwnProperty("isRateParityWebAppPage") ? props.isRateParityWebAppPage : false;
    var manifestPath = "/manifest.json";
    if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].booleanState */ .Z.booleanState(props.property)) {
        manifestPath = "../../" + manifestPath.split("/")[1];
    }
    var showRateParityWidget = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_general_show_rateparity_widget") == 1 ? true : false;
    });
    var seoRobotsInstructions = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_search_engine_instuctions");
    });
    var showCookieYes = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_cookies_cookieyes_enable") == 1 ? true : false;
    });
    var cookiesYesIdentifier = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_cookies_cookieyes_identifier");
    });
    var cookiesYesScript = function() {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(cookiesYesIdentifier)) {
            return "https://cdn-cookieyes.com/client_data/" + cookiesYesIdentifier + "/script.js";
        }
        return null;
    };
    var rateParityHasLoaded = function() {
        if (true) {
            return document.getElementById("rp-allinone");
        }
        return true;
    };
    var cookieYesHasLoaded = function() {
        if (true) {
            return document.getElementsByClassName("cky-preference-center").length > 0;
        }
        return true;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props.font != null) {
            var head = document.getElementsByTagName("head")[0];
            var style = document.createElement("style");
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.type = "text/css";
            switch(props.font){
                case "Roboto Slab":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto+Slab&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', serif !important}";
                    break;
                case "Serif":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto+Slab:300,400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', serif !important}";
                    break;
                case "Roboto":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto:300,400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', sans-serif !important}";
                    break;
                case "Vollkorn":
                    link.href = "https://fonts.googleapis.com/css?family=Vollkorn:400,600,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Vollkorn', serif !important}";
                    break;
                case "Noto Sans":
                    link.href = "https://fonts.googleapis.com/css?family=Noto+Sans:400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Noto Sans', sans-serif !important}";
                    break;
                case "Cousine":
                    link.href = "https://fonts.googleapis.com/css?family=Cousine:400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', monospace !important}";
                    break;
                case "Playfair":
                    link.href = "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Playfair Display', serif !important}";
                    break;
                default:
                    link.href = "https://fonts.googleapis.com/icon?family=Material+Icons&display=swap";
                    break;
            }
            head.appendChild(link);
            head.appendChild(style);
        }
    });
    var googleSchema = {
        "@context": "https://schema.org/",
        "@type": "Organization",
        "name": "".concat(props.googleSchemaTitle),
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "".concat(props.googleSchemaStreetAddress),
            "addressLocality": "".concat(props.googleSchemaCity),
            "addressRegion": "".concat(props.googleSchemaCountry),
            "postalCode": "".concat(props.googleSchemaZip)
        },
        "telephone": "".concat(props.googleSchemaPhone)
    };
    var descriptionFallback = "You need our help? Our team is here to assist you! Reach us via phone, email, or our contact form!";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: props.title
            }),
            props.keywords != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: props.titleOfficial
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(seoRobotsInstructions) ? seoRobotsInstructions : "index, follow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: props.designColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "referrer",
                content: "strict-origin"
            }),
            props.icon_60 != null && props.icon_60 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: props.icon_60
                    })
                ]
            }),
            props.icon_76 != null && props.icon_76 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "76x76",
                href: props.icon_76
            }),
            props.icon_120 != null && props.icon_120 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "120x120",
                href: props.icon_120
            }),
            props.icon_152 != null && props.icon_152 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "152x152",
                href: props.icon_152
            }),
            props.icon_256 != null && props.icon_256 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/x-icon",
                        href: props.icon_256
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "shortcut icon",
                        type: "image/x-icon",
                        href: props.icon_256
                    })
                ]
            }),
            props.icon != null && props.icon != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                href: props.icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-touch-fullscreen",
                content: "yes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-status-bar-style",
                content: "default"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "type",
                content: "place"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "place"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:type",
                content: "place"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(props.desc_fb_meta) && props.desc_fb_meta !== "" ? props.desc_fb_meta : descriptionFallback
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:description",
                content: props.desc_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: props.desc_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: props.image_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:image",
                content: props.image_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: props.image_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "250"
            }),
            props.lat_fb_meta != null && props.lat_fb_meta != "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "place:location:latitude",
                content: props.lat_fb_meta
            }) : null,
            props.lon_fb_meta != null && props.lon_fb_meta != "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "place:location:longitude",
                content: props.lon_fb_meta
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "url",
                content: props.domain
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: props.domain
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: props.domain
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: props.site_name_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image:alt",
                content: props.twitter_img_alt
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(googleSchema)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: manifestPath
            }),
            !cookieYesHasLoaded() && showCookieYes && cookiesYesScript != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                id: "cookieyes",
                type: "text/javascript",
                src: cookiesYesScript(),
                defer: true
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            !rateParityHasLoaded() && !isRateParityWebAppPage && showRateParityWidget ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "text/javascript",
                    src: "https://code.rateparity.com/versions/installer.min.js",
                    defer: true
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BuilderHead);


/***/ }),

/***/ 53408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ InlineStyles; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31969);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23158);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83974);





var InlineStyles = function(props) {
    var builderSettingsData = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["builderSettingsData"]["settings"];
    });
    var servicesHomepageRadious = props.app.servicesRadius;
    var servicesHomepageShadow = props.app.servicesShadow;
    var menuFontColor = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_header_menu_color_sticky");
    });
    var headerMenuColor = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_header_menu_color");
    });
    var disableUiControls = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].valueToBoolean */ .Z.valueToBoolean((0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_propertylist_map_disable_controls"));
    });
    var customStyles = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_custom_css");
    });
    var menuIconBorder = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].valueToBoolean */ .Z.valueToBoolean((0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_menu_icon_border"));
    });
    var builderPropertiesBorder = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_properties_border");
    });
    var builderPropertiesShadow = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_properties_shadow");
    });
    var builderPropertiesRadius = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_properties_radius");
    });
    var builderEstatesBorder = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_properties_estates_border");
    });
    var builderEstatesShadow = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_properties_estates_shadow");
    });
    var builderEstatesRadius = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_properties_estates_radius");
    });
    var builderBookingBoxBorder = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_booking_box_border");
    });
    var builderBookingBoxShadow = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_booking_box_shadow");
    });
    var builderBookingBoxRadius = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_booking_box_radius");
    });
    var builderPropertiesViewServicesBorder = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_propertyview_services_border");
    });
    var builderPropertiesViewServicesRadius = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_propertyview_services_radius");
    });
    var builderPropertiesViewServicesShadow = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_propertyview_services_shadow");
    });
    var builderDestinationsShadow = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_destinations_shadow");
    });
    var builderDestinationsBorder = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_destinations_border");
    });
    var builderDestinationsRadius = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_destinations_radius");
    });
    var builderCollectionsShadow = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_collections_shadow");
    });
    var builderCollectionsBorder = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_collections_border");
    });
    var builderCollectionsRadius = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_collections_radius");
    });
    var builderExperiencesBorder = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_experiences_border");
    });
    var builderExperiencesRadious = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_experiences_radius");
    });
    var builderExperiencesShadow = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_experiences_shadow");
    });
    var builderMenuSpacing = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_header_menu_spacing");
    });
    // const builderPropertiesBgColor = useSelector(state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_properties_bg_color'));
    // useEffect( () => {
    //     console.log("forDebug", "boxSetting[border]", builderPropertiesBorder)
    //     console.log("forDebug", "boxSetting[shadow]", builderPropertiesShadow)
    //     console.log("forDebug", "boxSetting[radius]", builderPropertiesRadius)
    //     console.log("forDebug", "boxSetting[bg-color]", builderPropertiesBgColor)
    // }, [])
    var getBuilderSettingByKey = function(key) {
        if (builderSettingsData == null || builderSettingsData == undefined) {
            return "#ffffff";
        }
        if (builderSettingsData.builder == undefined || builderSettingsData.builder == null) {
            return "#ffffff";
        }
        if (builderSettingsData.builder[key] == undefined || builderSettingsData.builder[key] == null) {
            return "#ffffff";
        }
        return builderSettingsData.builder[key];
    };
    // const propertiesTextColor = builderSettingsData!=undefined && builderSettingsData.builder.builder_properties_text_color!=undefined && builderSettingsData.builder.builder_properties_text_color.length>0 ? builderSettingsData.builder.builder_properties_text_color : null
    // const builder_properties_border = builderSettingsData.builder!=undefined && builderSettingsData.builder.builder_properties_border!=undefined && builderSettingsData.builder.builder_properties_border.length>0 ? builderSettingsData.builder.builder_properties_border : null
    // useEffect( () => {
    //     console.log("forDebug", "propertiesBackgroundColor", getBuilderSettingByKey('builder_properties_bg_color'))
    //     console.log("forDebug", "propertiesTextColor", getBuilderSettingByKey('builder_properties_text_color'))
    //     console.log("forDebug", "builder_properties_border", getBuilderSettingByKey('builder_properties_border'))
    //     console.log("forDebug", "builder_properties_shadow", getBuilderSettingByKey('builder_properties_shadow'))
    //     console.log("forDebug", "builder_properties_radius", getBuilderSettingByKey('builder_properties_radius'))
    // }, [builderSettingsData])
    var app = props.app;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    var initialiazeStyle = function() {
        // const head = document.getElementsByTagName('head')[0];
        // const style = document.createElement('style');
        // const link = document.createElement('link');
        // link.rel = 'stylesheet';
        // link.type = 'text/css';
        var style = {
            innerText: ""
        };
        // style.innerText = '';
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isHexColor */ .Z.isHexColor(menuFontColor)) {
            style.innerText += ".Header.Header-Light-Transparent.Header-Sticky-Top-Not .navbar-nav .nav-link { color: ".concat(menuFontColor, " }");
            style.innerText += ".Header.Header-Light-Transparent.Header-Sticky-Top-Not .navbar-nav .nav-link svg { color: ".concat(menuFontColor, " }");
            style.innerText += ".Header.Header-Light-Transparent.Header-Sticky-Top-Not svg { color: ".concat(menuFontColor, " }");
        }
        if (app.designColor != null && app.designColor != "") {
            style.innerText += ".navbar-design-color{background-color: ".concat(app.designColor, "!important}") + ".navbar-design-color.border-bottom{border-bottom: ".concat(app.designColor, "!important}") + ".main-design-color{color: ".concat(app.designColor, "!important}") + "div.cs-skin-slide > span:after, div.cs-skin-slide.cs-active > span:after{color: ".concat(app.designColor, "!important}") + ".nav-tab-dropdown .cs-select .cs-placeholder{color: ".concat(app.designColor, "!important;font-size: 13px; border-bottom: 1px solid ").concat(app.designColor, "; }") + ".nav-tabs-simple > li > a:after{background-color: ".concat(app.designColor, "!important}") + ".btn-design-color{background-color: ".concat(app.designColor, "!important;border: 1px solid ").concat(app.designColor, "!important;border-color: ").concat(app.designColor, "!important;").concat(app.designMode ? "color: #fff" : "color: #000", "!important;}") + ".bg-design-color{background-color: ".concat(app.designColor, "!important;border-color: ").concat(app.designColor, "!important}") + ".text-design-color{color: ".concat(app.designColor, "!important}") + ".btn-bordered-design-color > *{".concat(app.designMode ? "color: #fff!important;" : "color: #000!important;", "}") + ".btn-bordered-design-color:hover > *{color: ".concat(app.designColor, "!important;}") + ".btn-bordered-design-color{background: transparent!important;background-color: transparent!important; ".concat(app.designMode ? "color: #fff!important;" : "color: #000!important;", " ").concat(app.designMode ? "border: 2px solid #fff!important;" : "border: 2px solid #000!important;", "}") + ".btn-bordered-design-color:hover{".concat(app.designMode ? "background: #fff!important;background-color: #fff!important;" : "background: #000!important;background-color: #000!important;", " color: ").concat(app.designColor, "!important; ").concat(app.designMode ? "border: 2px solid #fff!important;" : "border: 2px solid #000!important;", "}");
        }
        if (rgbDesignColor != "bad_hex") {
            style.innerText += ".btn-design-color:hover {background-color: rgba(".concat(rgbDesignColor, ", .85)!important;border-color: ").concat(app.designColor, "!important;").concat(app.designMode ? "color: #fff" : "color: #000", "}") + ".btn-map.btn-design-color:hover{background-color: ".concat(app.designColor, "!important;border: 1px solid ").concat(app.designColor, "!important;border-color: ").concat(app.designColor, "!important;").concat(app.designMode ? "color: #fff" : "color: #000", "}") + ".MuiDateRangePickerDay-rangeIntervalDayHighlight{background-color: rgba(".concat(rgbDesignColor, ", .5) !important}") + ".MuiPickersDay-root.Mui-selected{background-color: rgba(".concat(rgbDesignColor, ") !important;text-shadow: 0px 0px 2px #000}") + ".form-group-default.focused{color: #212529!important;box-shadow: 0 0 0 0.25rem rgba(".concat(rgbDesignColor, ",.25)!important}");
        } else {
            style.innerText += ".btn-design-color:hover {background-color: ".concat(app.designColor, "!important;border-color: ").concat(app.designColor, "!important}");
        }
        if (app.designHeaderBgColor != null && app.designHeaderBgColor != "") {
            style.innerText += ".navbar-custom-color{background-color: ".concat(app.designHeaderBgColor, "!important}") + ".navbar-custom-color.border-bottom{border-bottom: ".concat(app.designHeaderBgColor, "!important}");
        }
        if (app.builder.builder_header_color != null && app.builder.builder_header_color != "") {
            style.innerText += ".Header-Custom-Color{background-color: ".concat(app.builder.builder_header_color, "!important}") + ".Header-Custom-Color.border-bottom{border-bottom: ".concat(app.builder.builder_header_color, "!important}");
        }
        if (app.designFontColor != null && app.designFontColor != "") {
            style.innerText += ".navbar-text-custom-color{color: ".concat(app.designFontColor, "!important}") + '.navbar-text-custom-color [class^="fa"]{color: '.concat(app.designFontColor, "!important}") + '.navbar-text-custom-color [class*="fa-"]{color: '.concat(app.designFontColor, "!important}") + ".navbar-text-custom-color .nav-item .nav-link{color: ".concat(app.designFontColor, "!important}") + '.navbar-text-custom-color .nav-item .nav-link [class^="fa"]{color: '.concat(app.designFontColor, "!important}") + '.navbar-text-custom-color .nav-item .nav-link [class*="fa-"]{color: '.concat(app.designFontColor, "!important}") + ".navbar-text-custom-color .nav-item .nav-link.btn{color: ".concat(app.designFontColor, "!important;background-color: transparent!important;border-color: ").concat(app.designFontColor, "!important}") + ".b-transparent-white.navbar-text-custom-color{color: ".concat(app.designFontColor, "!important;background-color: transparent!important;border-color: ").concat(app.designFontColor, "!important}");
        }
        if (app.designHeaderBgColor != null && app.designHeaderBgColor != "") {
            style.innerText += ".navbar-design-color{color: ".concat(app.designHeaderBgColor, "!important}");
        }
        if (app.searchbarBgColor != null) {
            style.innerText += ".searchbar-bg-color{background-color: ".concat(app.searchbarBgColor, "!important}") + ".btn-search-color{background-color: ".concat(app.searchbarBgColor, "!important;border-color: ").concat(app.searchbarBgColor, "!important}");
        }
        if (rgbSearchbarColor != "bad_hex") {
            style.innerText += ".btn-search-color:hover{background-color: rgba(".concat(rgbSearchbarColor, ", .85) !important;border-color: ").concat(app.searchbarBgColor, "!important}") + ".MuiDateRangePickerDay-rangeIntervalDayHighlight{background-color: rgba(".concat(rgbSearchbarColor, ", .5) !important}") + ".MuiPickersDay-root.Mui-selected{background-color: rgba(".concat(rgbSearchbarColor, ") !important;text-shadow: 0px 0px 2px #000}");
        } else {
            style.innerText += ".btn-search-color:hover{background-color: ".concat(app.searchbarBgColor, "!important;border-color: ").concat(app.searchbarBgColor, "!important}");
        }
        if (builderPropertiesBorder != null || builderPropertiesRadius != null || builderPropertiesShadow != null) {
            style.innerText += ".design-box {";
            style.innerText += "overflow: hidden !important;";
            if (builderPropertiesRadius != null) {
                style.innerText += "border-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-webkit-border-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-khtml-border-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "border-top-left-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-top-left-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-top-right-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "border-top-right-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-right-left-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-right-right-radius: ".concat(builderPropertiesRadius, "px !important;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (builderPropertiesShadow == 1) {
                style.innerText += "box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderPropertiesBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
            style.innerText += ".Properties.Properties-Thumb.Properties-Border.Properties-Shadow .Properties__gallery,\n                .Properties.Properties-Thumb.Properties-Border.Properties-Shadow .Properties__gallery > div {";
            style.innerText += "overflow: hidden !important;";
            if (builderPropertiesRadius != null) {
                style.innerText += "border-top-left-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-top-left-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-top-right-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "border-top-right-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-right-left-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-right-right-radius: ".concat(builderPropertiesRadius, "px !important;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        if (builderEstatesBorder != null || builderEstatesRadius != null || builderEstatesShadow != null) {
            style.innerText += ".design-box-estates {";
            style.innerText += "overflow: hidden !important;";
            if (builderEstatesRadius != null) {
                style.innerText += "border-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-webkit-border-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-khtml-border-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "border-top-left-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-top-left-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-top-right-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "border-top-right-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-right-left-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-right-right-radius: ".concat(builderEstatesRadius, "px !important;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (builderEstatesShadow == 1) {
                style.innerText += "box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderEstatesBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
            style.innerText += ".Properties.Properties-Thumb.Properties-Border.Properties-Shadow .Properties__gallery,\n                .Properties.Properties-Thumb.Properties-Border.Properties-Shadow .Properties__gallery > div {";
            style.innerText += "overflow: hidden !important;";
            if (builderEstatesRadius != null) {
                style.innerText += "border-top-left-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-top-left-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-top-right-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "border-top-right-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-right-left-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-right-right-radius: ".concat(builderEstatesRadius, "px !important;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            style.innerText += "}";
        // border-radius: ${builderEstatesRadius}px;box-shadow: ${builderEstatesShadow};border: ${builderEstatesBorder}px solid #eeeeee`
        }
        if (builderBookingBoxBorder != null || builderBookingBoxRadius != null || builderBookingBoxShadow != null) {
            style.innerText += ".booking-orders-design-box {";
            if (builderBookingBoxRadius != null) {
                style.innerText += "border-radius: ".concat(builderBookingBoxRadius, "px;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (builderBookingBoxShadow == 1) {
                style.innerText += "box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderBookingBoxBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        if (builderPropertiesViewServicesBorder != null || builderPropertiesViewServicesRadius != null || builderPropertiesViewServicesShadow != null) {
            style.innerText += ".service-item-design-box {";
            if (builderPropertiesViewServicesRadius != null) {
                style.innerText += "border-radius: ".concat(builderPropertiesViewServicesRadius, "px;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(builderPropertiesViewServicesShadow)) {
                style.innerText += "box-shadow: 0 0 " + builderPropertiesViewServicesShadow + "px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0 0 " + builderPropertiesViewServicesShadow + "px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0 0 " + builderPropertiesViewServicesShadow + "px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderPropertiesViewServicesBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "overflow: hidden;";
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        if (builderPropertiesBorder != null || builderPropertiesRadius != null || builderPropertiesShadow != null) {
            style.innerText += ".design-box-service {";
            if (builderPropertiesRadius != null) {
                style.innerText += "border-radius: ".concat(builderPropertiesRadius, "px;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (builderPropertiesShadow == 1) {
                style.innerText += "box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderPropertiesBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        if (builderDestinationsRadius != null || builderDestinationsBorder != null || builderDestinationsShadow != null) {
            style.innerText += ".design-box-destination {";
            if (builderDestinationsRadius != null) {
                style.innerText += "border-radius: ".concat(builderDestinationsRadius, "px;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (builderDestinationsShadow == 1) {
                style.innerText += "box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderDestinationsBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        if (builderCollectionsShadow != null || builderCollectionsBorder != null || builderCollectionsRadius != null) {
            style.innerText += ".design-box-collection, .design-box-collection .card { overflow: hidden; ";
            if (builderCollectionsRadius != null) {
                style.innerText += "border-radius: ".concat(builderCollectionsRadius, "px;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (builderCollectionsShadow == 1) {
                style.innerText += "box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderCollectionsBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        if (builderExperiencesRadious != null || builderExperiencesShadow != null || builderExperiencesBorder != null) {
            style.innerText += ".experience-design-box { overflow: hidden; ";
            if (builderExperiencesRadious != null) {
                style.innerText += "border-radius: ".concat(builderExperiencesRadious, "px;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(builderExperiencesShadow)) {
                style.innerText += "box-shadow: 0px 0px " + builderExperiencesShadow + "px -5px rgba(0, 0, 0, 0.25) !important;";
                style.innerText += "-webkit-box-shadow: 0px 0px " + builderExperiencesShadow + "px -5px rgba(0, 0, 0, 0.25) !important;";
                style.innerText += "-moz-box-shadow: 0px 0px " + builderExperiencesShadow + "px -5px rgba(0, 0, 0, 0.25) !important;";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderExperiencesBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        // builderMenuSpacing
        style.innerText += ".navbar-nav > li > a { ";
        if (builderMenuSpacing == "default") {
            style.innerText += "padding: 10px 12px ";
        } else if (builderMenuSpacing == "comfortable") {
            style.innerText += "padding: 10px 15px ";
        } else if (builderMenuSpacing == "compact") {
            style.innerText += "padding: 10px 9px ";
        }
        style.innerText += "}";
        style.innerText += ".service-item-homepage {";
        style.innerText += "box-shadow: 0px 0px " + servicesHomepageShadow + "px -5px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0px 0px " + servicesHomepageShadow + "px -5px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0px 0px " + servicesHomepageShadow + "px -5px rgba(0, 0, 0, 0.25);";
        style.innerText += "border-radius: ".concat(servicesHomepageRadious, "px !important;");
        style.innerText += "overflow: hidden;";
        style.innerText += "}";
        style.innerText += ".nav-tabs-fillup > li > a:after { background-color: rgb(" + rgbDesignColor + "); border: none; }";
        style.innerText += ".nav-tabs-fillup > li > a.active > span.main-design-color { color: rgb(255, 255, 255) !important; }";
        if (disableUiControls) {
            style.innerText += "#map .gm-style { pointer-events: none !important; }";
        }
        if (menuIconBorder) {
            style.innerText += ".Header.Header-Dark-Transparent .navbar-toggle { border: 2px solid #ffffff !important; }";
            style.innerText += ".Header.Header-Dark-Transparent .navbar-toggle svg { margin-top: 2px; }";
            style.innerText += ".Header.Header-Light .navbar-toggle svg { margin-top: 2px; }";
            style.innerText += ".Header.Header-Light .navbar-toggle { border: 2px solid " + headerMenuColor + " !important; }";
        }
        style.innerText += customStyles;
        // head.appendChild(style);
        // console.log("style.innerText", style.innerText)
        return style.innerText;
    };
    // useEffect(() => {
    //     initialiazeStyle()
    // });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
            dangerouslySetInnerHTML: {
                __html: initialiazeStyle()
            }
        })
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (InlineStyles)));


/***/ }),

/***/ 11101:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(93060)


/***/ })

}]);